import s from '@corratech/air-ooka-header/StoreSwitcher/StoreSwitcher.module.scss'
import { useTranslation } from 'next-i18next'
import cn from 'classnames'
import { Active } from '@corratech/air-ooka-header/StoreSwitcher/Flags/Active'
import { useRouter } from 'next/router'
import Link from '@corratech/pylot-ui/src/Link'
import { StoreSwitcherConfigType } from '@corratech/air-ooka-header/StoreSwitcher/use-StoreSwitcherConfig'
import { useRef } from 'react'
export const StoreSwitcherPopup = ({
    allStores,
    closePopup,
    displayStoreSwitcherPopup
}: {
    closePopup: () => void
    allStores: StoreSwitcherConfigType[]
    displayStoreSwitcherPopup: boolean
}) => {
    const { t } = useTranslation('common')
    const storeSwitcherPopupRef = useRef<HTMLDivElement | null>(null)
    const router = useRouter()

    const handleClick = (
        e: React.MouseEvent<HTMLAnchorElement>,
        url: string,
        locale: string,
        isActiveStore: boolean
    ) => {
        closePopup()
        if (isActiveStore) {
            e.preventDefault()
            const newUrl = `${url}${locale}${router.asPath}`
            document.cookie = `NEXT_LOCALE=${locale}; max-age=31536000; path=/`
            window.location.href = newUrl
        }
    }

    return (
        <div
            className={cn(
                s.StoreSwitcherPopup,
                displayStoreSwitcherPopup && s.displayStoreSwitcherPopup
            )}
            ref={storeSwitcherPopupRef}
        >
            <span className={s.StoreSwitcherHeader}>
                {t('country and language')}
            </span>
            {allStores?.map((store) => {
                const isActiveStore =
                    store.store === process.env.NEXT_PUBLIC_STORE_CODE
                return (
                    <div key={`${store.store}`} className={s.StoreSwitcherItem}>
                        <div className={s.StoreSwitcherFlag}>
                            {store.flag}
                            <span>{store.country}</span>
                        </div>
                        {Object.entries(store.locales).map(([key, value]) => {
                            const isActive =
                                router.locale === key && isActiveStore

                            return (
                                <Link
                                    key={`${store.store}_${key}`}
                                    className={cn(
                                        s.languageLabel,
                                        isActive &&
                                            s.StoreSwitcherItemLocaleActive
                                    )}
                                    href={`${store.url}/${key}`}
                                    onClick={(e) => {
                                        handleClick(
                                            e,
                                            store.url as string,
                                            key,
                                            isActiveStore
                                        )
                                    }}
                                >
                                    <>
                                        {value}
                                        <Active />
                                    </>
                                </Link>
                            )
                        })}
                    </div>
                )
            })}
        </div>
    )
}
